// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2ywFR","inputWrap":"styles_inputWrap__cen3w","input":"styles_input__2_phU"};